import { createRouter, createWebHistory } from "vue-router"

import store from "../store/index"

const DEFAULT_TITLE = "Editor"

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Dashboard.vue"),
    meta: { transition: "pages-fade", title: DEFAULT_TITLE + " – Dashboard" },
  },
  {
    path: "/modules/:id",
    name: "module",
    meta: { transition: "pages-fade", title: DEFAULT_TITLE + " – Модули" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ModuleItems.vue"),
  },
  {
    path: "/modules",
    name: "module_list",
    meta: { transition: "pages-fade", title: DEFAULT_TITLE + " – Модули" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Modules.vue"),
  },
  {
    path: "/users",
    name: "users",
    meta: {
      transition: "pages-fade",
      title: DEFAULT_TITLE + " – Пользователи",
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Users.vue"),
  },
  {
    path: "/users/add",
    name: "users_add",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UsersAdd.vue"),
  },
  {
    path: "/users/:userid",
    name: "users_edit",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UsersAdd.vue"),
  },
  {
    path: "/pages",
    name: "pages",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PagesList.vue"),
  },
  {
    path: "/pages/:pageid",
    name: "pages_edit",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PagesEdit.vue"),
  },
  {
    path: "/reports",
    name: "reports",
    meta: { transition: "pages-fade", title: DEFAULT_TITLE + " – Отчеты" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Reports.vue"),
  },
  {
    path: "/modules/:id/add",
    name: "module_add_item",
    meta: { transition: "pages-fade" },
    component: () => import("../views/ModuleNewItem.vue"),
    children: [
      {
        path: "clone/:cloneid",
        name: "module_clone_item",
        component: import("../views/ModuleNewItem.vue"),
      },
    ],
  },

  {
    path: "/modules/:id/multiedit",
    name: "module_multi_edit",
    meta: { transition: "pages-fade" },
    component: () => import("../views/ModuleItemsMultiedit.vue"),
  },

  {
    path: "/modules/:id/edit/:itemid",
    name: "module_edit_item",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ModuleNewItem.vue"),
  },
  {
    path: "/services/sales_1c",
    name: "sales_1c",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ServicesSales.vue"),
  },
  {
    path: "/services/compare_1c",
    name: "compare_1c",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ServicesCompare.vue"),
  },
  {
    path: "/services/prices",
    name: "prices",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ServicesPrices.vue"),
  },
  {
    path: "/services/refresh",
    name: "refresh",
    meta: { transition: "pages-fade" },
    component: () => import("../views/ServicesRefresh.vue"),
  },
  {
    path: "/services/revaluation",
    name: "revaluation",
    meta: { transition: "pages-fade" },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/ServicesRevaluation.vue"
      ),
  },
  {
    path: "/services/emails",
    name: "emails",
    meta: { transition: "pages-fade" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ServicesEmails.vue"),
  },
  {
    path: "/options",
    name: "options",
    meta: { transition: "pages-fade", title: DEFAULT_TITLE + " – Параметры" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Options.vue"),
  },
  {
    path: "/seo",
    name: "seo",
    meta: { transition: "pages-fade", title: DEFAULT_TITLE + " – SEO" },
    component: () => import(/* webpackChunkName: "about" */ "../views/Seo.vue"),
  },
  {
    path: "/carts",
    name: "carts",
    meta: { transition: "pages-fade", title: DEFAULT_TITLE + " – Корзины" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Carts.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { transition: "pages-fade", title: DEFAULT_TITLE + " – вход" },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue"),
  },
  // {
  //   path: "/artists/:id",
  //   name: "artist",
  //   meta: { transition: "none" },
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/ArtistView.vue"),
  // },
]

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // scrollBehavior: (to, from, savedPosition) => {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else if (to.hash) {
  //     return {
  //       selector: to.hash,
  //     t
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // },
})

router.beforeEach(function (to, from, next) {
  // if (to.meta.requiresAuth && !auth.isLoggedIn()) {
  console.log(store.getters.getUserRole())
  if (to.name !== "login" && store.getters.getUserRole() == "") {
    // console.log("test routing to login")
    // next({ name: "login" })
    // return "/login"
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // return {
    //   path: "/login",
    //   // save the location we were at to come back later
    //   query: { redirect: to.fullPath },
    // }
    next()
  } else next()

  // if (to.meta.transition != "none")
  //   // console.log(to.meta.transition != "none")
  //   store.dispatch("setPagesTransition", true)

  // setTimeout(() => {
  //   window.scrollTo(0, 0)
  // }, 100)

  // setTimeout(() => {
  //   store.dispatch("setPagesTransition", false)
  // }, 352.5)

  // next()
})

router.afterEach((to) => {
  // Vue.nextTick(() => {
  document.title = to.meta.title || DEFAULT_TITLE
  // })
})

export default router
